import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components/macro'
import { SyncLoader } from 'react-spinners'
import { LoaderContainer } from './CardImageLoaderStyledComponents'

const CardImageLoader = React.memo(({ innerRef, theme, ...rest }) => (
  <LoaderContainer ref={innerRef} {...rest}>
    <SyncLoader color={theme.productPlusButtonBackground} show size={10} />
  </LoaderContainer>
))

CardImageLoader.displayName = 'CardImageLoader'

CardImageLoader.propTypes = {
  innerRef: PropTypes.func,
  theme: PropTypes.object.isRequired
}

export default withTheme(CardImageLoader)
